/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMoneyInChequeDetailsInput
 */
export interface GetMoneyInChequeDetailsInput {
    /**
     * 
     * @type {string}
     * @memberof GetMoneyInChequeDetailsInput
     */
    updateDate?: string;
    /**
     * End Date UTC Unix Timestamp
     * @type {string}
     * @memberof GetMoneyInChequeDetailsInput
     */
    updateEndDate?: string;
    /**
     * Cheque Payment (by default) or Pagaré:<br/>15 = Cheque payment.<br/>23 = Pagaré.<br/>
     * @type {number}
     * @memberof GetMoneyInChequeDetailsInput
     */
    chequeType?: GetMoneyInChequeDetailsInputChequeTypeEnum;
    /**
     * Unique ID generated by your server
     * @type {string}
     * @memberof GetMoneyInChequeDetailsInput
     */
    reference?: string;
}


/**
 * @export
 */
export const GetMoneyInChequeDetailsInputChequeTypeEnum = {
    NUMBER_15: 15,
    NUMBER_23: 23
} as const;
export type GetMoneyInChequeDetailsInputChequeTypeEnum = typeof GetMoneyInChequeDetailsInputChequeTypeEnum[keyof typeof GetMoneyInChequeDetailsInputChequeTypeEnum];


/**
 * Check if a given object implements the GetMoneyInChequeDetailsInput interface.
 */
export function instanceOfGetMoneyInChequeDetailsInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInChequeDetailsInputFromJSON(json: any): GetMoneyInChequeDetailsInput {
    return GetMoneyInChequeDetailsInputFromJSONTyped(json, false);
}

export function GetMoneyInChequeDetailsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInChequeDetailsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'updateDate': !exists(json, 'updateDate') ? undefined : json['updateDate'],
        'updateEndDate': !exists(json, 'updateEndDate') ? undefined : json['updateEndDate'],
        'chequeType': !exists(json, 'chequeType') ? undefined : json['chequeType'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
    };
}

export function GetMoneyInChequeDetailsInputToJSON(value?: GetMoneyInChequeDetailsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'updateDate': value.updateDate,
        'updateEndDate': value.updateEndDate,
        'chequeType': value.chequeType,
        'reference': value.reference,
    };
}

